var _Grid$Item;

import React from 'react';
import Grid from '../Grid';
import Heading from '../../Typography/Heading';
import Container from '../../Common/Container';
import styles from './Content.scss';

var Content = function Content(_ref) {
  var title = _ref.title,
      content = _ref.content;
  return /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Grid.Row, null, _Grid$Item || (_Grid$Item = /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 2,
    lg: 2,
    sm: 4,
    xs: 4
  })), /*#__PURE__*/React.createElement(Grid.Item, {
    xl: 4,
    lg: 4,
    sm: 4,
    xs: 4
  }, /*#__PURE__*/React.createElement(Container, {
    marginBottom: 6,
    marginBottomSm: 4,
    marginBottomXs: 3
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 1
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    dangerouslySetInnerHTML: {
      __html: content
    }
  }))));
};

export default Content;